export default {
  'home.top.title': '最專業的獨角獸投資轉讓平臺 ',
  'home.top.desc': '要投就投最好的',
  'home.center.title1': '熱門獨角獸',
  'home.center.title2': '最新公告',
  'home.center.title3': '如何操作',
  'home.center.valuation': '估值',
  'home.help.title1': '加入CTFEX',
  'home.help.title2': '投資獨角獸',
  'home.help.title3': '回購和轉讓',
  'home.help.desc1': '1秒註冊，加入投資獨角獸俱樂部',
  'home.help.desc2': '瀏覽獨角獸內參早投資贏在上市',
  'home.help.desc3': '項目上市整體退出或者直接轉賣',
  'home.unicorn.purchase': '立即認購',
  'home.unicorn.transfer': '立即交易',


  ////以下是新
  'account.plan.end.title': '截止認購',
  'account.plan.stock.name': '新股',
  'account.plan.action': '決策',
  'account.plan.stock.code': '股票',
  'account.plan.onhand.got.rate': '一手中簽率',
  'account.plan.sell.profit': '賣出收益',
  'account.plan.avg.profit': '中簽平均收益',
  'account.plan.create.time': '創建時間',
  'account.plan.currenct.asset': '當前凈值',
  'account.plan.manager': '管理人',
  'account.plan.action.now': '當前打新決策',
  'account.plan.weight.curve': '加權收益率曲線',
  'account.plan.history': '歷史打新項目',
  'account.plan.notice': '提示',
  'account.plan.have.close': '本計劃已封閉，不能加入',
  'account.trust.have.close': '此信托已關閉,不能申購和贖回',

  'finance.page.title': '理財',
  'finance.list.title1': '委托打新',
  'finance.list.title2': '優選理財',
  'finance.list1': '理享家優選',
  'finance.list2': '辰宇投資優選',
  'finance.list3': '善水家族辦公室',
  'finance.list.tip': '請先完成專業投資者認證，如有疑問，請聯系在線客服',
  'finance.table1': '價格',
  'finance.table2': '時間',
  'finance.modal1': '加入後，將跟隨本計劃參與打新並自動上市當天賣出。如需自主決策，您可',
  'finance.modal2': '個工作日後自由退出本計劃。',
  'finance.modal3': '為最大化提高您賬戶資金的利用效率，本計劃要求凈資產在',
  'finance.modal4': '之間',
  'finance.modal5': '加入計劃內',
  'finance.modal6': '天不能退出計劃',
  'finance.modal7': '本計劃要求凈資產在',
  'finance.modal8': '之間',

  'header.nav10': '教育',
  'edu.tip': '內容僅供參考，不構成稅務或投資建議，也不構成對任何證券或交易策略的建議。投資有風險，請投資者根據自身的投資偏好及知識做出投資決定。',
  'edu.library': '圖書館',
  'edu.update': '更新',
  'edu.author': 'WBroker教育',
  'edu.viewMore': '探索',
  'edu.question.title': '這回答了你的問題嗎？',
  'edu.question.answer': '人中，有',
  'edu.question.answer2': '人說這回答了他們的問題。',
  'edu.used': '有用!',
  'edu.unused': '沒用!',
  'edu.deal.title': '準備好開始投資了嗎？',
  'edu.deal.desc': '在WBroker註冊開戶，並得到你的第一個股票。',
  'edu.deal': '開始交易',
  'edu.more.detail': '更多內容',

  'edu.register': '註冊',

  'finance.modal9': '加入本計劃凈資產需大於',
  'finance.moda20': ',以及現金余額大於',
  'finance.moda21': '有新股掛單或者新股持倉時不能加入本計劃',

  'account.plan.join.ok': ' 恭喜您添加成功',
  'account.plan.join.fail.notice': ' 您已參加其他委托計劃，不能參加本計劃',
  'account.plan.join.message.fail': ' 有掛單或者持倉時不能加入本計劃',
  'account.plan.have.quit': '已退出本計劃',
  'account.plan.join.fail': '委托計劃失敗',
  'account.plan.join.other.fail': '您已參加其他委托計劃，不能參加本計劃',
  'account.plan.stock.pick': '打',
  'account.plan.stock.nopick': '不打',
  'account.plan.stock.wait.pick': '待定',

  'modal.common.ok.text2': '知道了',
  'modal.common.sure.text': '確定',
  'modal.common.sure.text2': '確認',
  'modal.common.cancel.text': '取消',
  'modal.common.quit.text1': '繼續開戶',
  'modal.common.quit.text2': '退出登錄',

  'account.plan.join.ask': ' 確定加入計劃？',
  'account.plan.quit.ask': ' 確定退出計劃？',

  'account.plan.out.other.fail': '有掛單或者持倉時不能退出本計劃',
  'account.plan.out.part.fail': '有新股掛單或者新股持倉時不能退出本計劃',




  'form.user.set.validate.input.mobile.is.ok': '手機號不正確',
  'form.user.set.validate.input.mobile': '請輸入手機號',
  'form.user.set.validate.input.email': '請輸入電子郵箱',
  'form.user.set.validate.input.email.is.ok': '電子郵箱不正確',
  'form.user.set.prefix.password': '登錄密碼',
  'form.user.set.prefix.txpassword': '交易密碼',
  'form.user.set.validate.encryptPwd.is.ok': '密碼規則不匹配',
  'form.user.set.prefix.origin.password': '原登錄密碼',
  'form.user.set.prefix.origin.txpassword': '原交易密碼',

  'form.placeholder.input.new.mobile': '請輸入新手機',
  'form.user.login.prefix.new.email': '新郵箱',

  'form.safe.invest.prefix.major.income': '您的主要收入來源是',
  'form.safe.invest.major.income.A': '工資、勞務報酬',
  'form.safe.invest.major.income.B': '生產經營所得',
  'form.safe.invest.major.income.C': '利息、股息、轉讓等金融性資產收入',
  'form.safe.invest.major.income.D': '出租、出售房地產等非金融性資產收入',
  'form.safe.invest.major.income.E': '無固定收入',

  'form.safe.invest.prefix.house.income': '您的家庭可支配年收入為（折合人民幣）',
  'form.safe.invest.house.income.A': '20萬元以下',
  'form.safe.invest.house.income.B': '20-100萬元',
  'form.safe.invest.house.income.C': '100-500萬元',
  'form.safe.invest.house.income.D': '500-1000萬元',
  'form.safe.invest.house.income.E': '1000萬元以上',

  'form.safe.invest.prefix.financial.invest': '在您每年的家庭可支配收入中，可用於金融投資（儲蓄存款除外）的比例為？',
  'form.safe.invest.financial.invest.A': '小於10%',
  'form.safe.invest.financial.invest.B': '10%-25%',
  'form.safe.invest.financial.invest.C': '25%-50%',
  'form.safe.invest.financial.invest.D': '大於50%',

  'form.safe.invest.prefix.debt': '您是否有尚未清償的數額較大的債務，如有，其性質是',
  'form.safe.invest.debt.A': '沒有',
  'form.safe.invest.debt.B': '有，住房抵押貸款等長期定額債務',
  'form.safe.invest.debt.C': '有，信用卡欠款、消費信貸等短期信用債務',
  'form.safe.invest.debt.D': '有，親戚朋友借款',


  'form.safe.invest.prefix.investment.knowledge': '您的投資知識可描述為',
  'form.safe.invest.investment.knowledge.A': '有限，幾乎沒有金融方面的知識',
  'form.safe.invest.investment.knowledge.B': '一般，對於金融產品和相關風險具有基本的認識和理解',
  'form.safe.invest.investment.knowledge.C': '豐富，對於金融產品和相關風險具有豐富的認識和理解',


  'form.safe.invest.prefix.investment.experience.desc': '您的投資經驗可描述為',
  'form.safe.invest.investment.experience.desc.A': '除銀行儲蓄外，基本沒有其他投資經驗',
  'form.safe.invest.investment.experience.desc.B': '購買過債券、保險等理財產品',
  'form.safe.invest.investment.experience.desc.C': '參與過股票、基金等產品的交易',
  'form.safe.invest.investment.experience.desc.D': '參與過權證、期貨、期權等產品的交易',

  'form.safe.invest.prefix.investment.experience': '您有多少年投資基金、股票、信托、私募證券或金融衍生產品等風險投資品的經驗？',
  'form.safe.invest.investment.experience.A': '沒有經驗',
  'form.safe.invest.investment.experience.B': '少於 2 年',
  'form.safe.invest.investment.experience.C': '2 至 5 年',
  'form.safe.invest.investment.experience.D': '5 至 10 年',
  'form.safe.invest.investment.experience.E': '10 年以上',

  'form.safe.invest.prefix.investment.horizon': '您計劃的投資期限有多久',
  'form.safe.invest.investment.horizon.A': '1年以下',
  'form.safe.invest.investment.horizon.B': '1-3年',
  'form.safe.invest.investment.horizon.C': '3-5年',
  'form.safe.invest.investment.horizon.D': '5年以上',

  'form.safe.invest.prefix.investment.varieties': '您打算重點投資於哪些種類的投資品種？',
  'form.safe.invest.investment.varieties.A': '債券、貨幣市場基金、債券基金等固定收益類投資品種',
  'form.safe.invest.investment.varieties.B': '股票、混合型基金、股票型基金等權益類投資品種',
  'form.safe.invest.investment.varieties.C': '期貨、期權等金融衍生品',
  'form.safe.invest.investment.varieties.D': '其他產品或者服務',

  'form.safe.invest.prefix.investment.attitude': '以下哪種符合您的投資態度',
  'form.safe.invest.investment.attitude.A': '厭惡風險，不希望本金損失，希望有穩定的回報',
  'form.safe.invest.investment.attitude.B': '保守投資，不希望本金損失，可以一定幅度的接受收益波動',
  'form.safe.invest.investment.attitude.C': '尋求資金的較高收益和成長性，願意為此承擔有限本金損失',
  'form.safe.invest.investment.attitude.D': '希望賺取高回報，願意為此承擔較大本金損失',

  'form.safe.invest.prefix.investment.question': '假設有兩種投資：A預期獲得10%的收益，可能承擔的損失非常小；投資B預期獲得30%的收益，但可能承擔較大的損失；您會怎麽支配您的投資',
  'form.safe.invest.investment.question.A': '全部投資收益較小且損失較小的A',
  'form.safe.invest.investment.question.B': '同時投資於A和B，但大部分資金投資於損失較小且收益較少的A',
  'form.safe.invest.investment.question.C': '同時投資於A和B，但大部分資金投資於損失較大且收益較多的B',
  'form.safe.invest.investment.question.D': '全部投資於收益大且風險大的B',

  'form.safe.invest.prefix.biggest.loss': '您認為自己能承受的最大損失是多少',
  'form.safe.invest.biggest.loss.A': '10%以內',
  'form.safe.invest.biggest.loss.B': '10%-30%',
  'form.safe.invest.biggest.loss.C': '30%-50%',
  'form.safe.invest.biggest.loss.D': '50%以上',

  'form.user.safe.investor.btn.submit': '提交認證',


  'form.user.safe.investor.validation.error': '本選項不符合合格投資者要求，將不能投資本網站產品',


  'form.user.safe.name.prefix.card.type': '證件類型',
  'form.user.safe.name.prefix.real.name': '姓名',
  'form.user.safe.name.prefix.card.number': '證件號碼',
  'form.user.safe.name.placeholder.input.id': '請輸入證件號碼',
  'form.user.safe.name.placeholder.input.name': '請輸入真實姓名',
  'form.user.safe.name.idcard': '身份證',
  'form.user.safe.name.passport': '護照',
  'form.user.safe.name.passport.other': '其他證件',
  'form.user.safe.name.driver': '駕照',

  'form.user.safe.name.validate.input.name': '請填寫真實姓名',
  'form.user.safe.name.validate.input.idcard.is.ok': '請填寫正確的身份證號碼',


  'form.account.name.prefix.idcard': '身份證號',
  'form.account.name.prefix.expiry.date': '有效期截止',
  'form.account.name.placeholder.input.expiry.date': '有效期截止日期(1990-01-01)',
  'form.account.name.prefix.address': '居住地址',
  'form.account.name.placeholder.input.address': '請輸入居住地址',
  'form.account.name.prefix.issue.address': '證件地址',
  'form.account.name.placeholder.input.issue.address': '請輸入證件地址',
  'form.account.name.validate.idcard.error': '身份證號碼有誤',
  'form.account.name.validate.date.error': '有效期格式有誤,(例如：1990-01-01)',
  'form.account.name.validate.input.address': '請輸入地址',
  'form.account.name.prefix.address.prove': '地址證明(水電賬單，信用卡賬單等，須寫明您的姓名的地址)',
  'form.upload.text': '點擊上傳',
  'form.upload.picture.to.max': '圖片太大',
  'form.account.name.upload.click.front': '上傳人像面',
  'form.account.name.upload.click.back': '上傳國徽面',
  'form.account.name.upload.click.hold': '上傳手持證件照',
  'form.account.name.card.example': '證件正確示範圖，點擊可查看',
  'form.account.name.prefix.show.address': '居住地址同身份證地址相同',
  'form.account.name.upload.click.info': '上傳個人信息頁面',
  'form.account.name.upload.click.info.back': '證件反面',
  'form.account.name.upload.click.info.hand': '上傳手持證件照',
  'form.account.name.prefix.card.number': '證件號碼',
  'form.user.login.validate.input.expiry.date': '請輸入有效日期',
  'form.account.name.placeholder.input.card.expiry.date': '格式(YYYYMMDD-YYYYMMDD)',
  'form.account.name.validate.upload.address': '請上傳地址證明文件',

  'form.account.name.upload.click.face': '點擊人臉識別',


  'form.account.last.step': '上一步',
  'form.account.type': '開戶證件類型',
  'form.account.type1': '大陸身份證',
  'form.account.type2': '香港身份證',
  'form.account.ocr.fail': 'ocr識別身份信息失敗，請重新上傳',
  'form.account.phone.tip': '拍攝提示',
  'form.account.version.old': '當前版本過舊，請前往官網下載最新版本進行開戶',
  'form.account.goto.download': '去下載',
  'form.account.open.type': '開戶證件',
  'form.account.open.ocr': '正在OCR識別身份',
  'form.account.open.face': '正在處理人臉信息',
  'form.account.click.cam': '請點擊相機圖標，進行人臉識別',
  'form.account.face.again': '人臉識別上傳失敗，請點擊重試或聯系在線客服處理',
  'form.account.face': '人臉識別',
  'form.account.click.upload': '點擊上傳地址證明',
  'form.account.address.approve': '點擊上傳地址證明',
  'form.account.house.has': '擁有',
  'form.account.house.use': '租用',
  'form.account.house.with': '與親戚同住',
  'form.account.stepGrray1': '0年',
  'form.account.stepGrray2': '1年-3年',
  'form.account.stepGrray3': '3年-10年',
  'form.account.stepGrray4': '>10年',
  'form.account.stepGrrayChildren1': '股票、債券及其他證券',
  'form.account.stepGrrayChildren2': '杠桿外匯',
  'form.account.stepGrrayChildren3': '貴重金屬',
  'form.account.stepGrrayChildren4': '期貨/期權',
  'form.account.stepHrray1': '了解',
  'form.account.stepHrray2': '不了解',
  'form.account.stepHrrayChildren1': '擁有曾買賣衍生產品的經驗',
  'form.account.stepHrrayChildren2': '曾接受有關衍生產品的培訓或修讀相關課程',
  'form.account.stepHrrayChildren3': '擁有涉及衍生工具的工作經驗',
  'form.account.choose.houseStatus': '請選擇住房情況',
  'form.account.houseStatus.value': '請輸入估值',
  'form.account.houseStatus.number': '房屋估值只能輸入數字',
  'form.account.work.status': '請選擇就業狀態',
  'form.account.input.work.status': '請輸入就業情況',
  'form.account.choose.edu': '請選擇教育程度',
  'form.account.choose.asset': '請選擇總資產',
  'form.account.choose.income': '請選擇年收入',
  'form.account.choose.target': '請選擇投資目標',
  'form.account.choose.experience': '請選擇投資經驗',
  'form.account.choose.experienceType': '請選擇投資類型',
  'form.account.choose.derivativesKnowledge': '請選擇衍生品知識',
  'form.account.choose.hasKnowledge': '請選擇衍生工具知識',
  'form.account.choose.riskTolerance': '風險承受能力項不符合監管要求，您將不能開戶',
  'form.account.houseSituation': '住房情況',
  'form.account.valuation': '估值（扣除按揭）',
  'form.account.valuation.placeholder': '請填寫估值',
  'form.account.work.label1': '雇主姓名',
  'form.account.work.label1.placeholder': '請輸入雇主姓名',
  'form.account.work.label2': '職業/職務',
  'form.account.work.label2.placeholder': '請輸入職業/職務',
  'form.account.work.label3': '任職年期',
  'form.account.work.label3.placeholder': '請輸入任職年期',
  'form.account.work.label4': '職位',
  'form.account.work.label4.placeholder': '請輸入職位',
  'form.account.work.label5': '業務性質',
  'form.account.work.label5.placeholder': '請輸入業務性質',
  'form.account.investmentExperience': '投資類型',
  'form.account.derivativesKnowledge': '衍生品知識',
  'form.account.derivativesKnowledge0': '如何了解有關衍生工具知識',
  'form.account.risk': '風險披露',
  'form.account.risk.standar': '持牌代表：',
  'form.account.result.copy': '確定並復製微信號',
  'form.account.sign.upload.fail': '上傳手寫簽名失敗，請重試',
  'form.account.sign.reset': '重寫',

  'form.placeholder.input.password.new': '8-12位字母、數字和字符組合密碼',
  'form.placeholder.input.password.rule': '8-12位字母、數字和字符組合密碼',

  'menu.account.name': 'WBroker實名認證 ',
  'menu.account.add': '補充資料',

  'v3.menu.plan': '理財',
  'v3.menu.plan.detail': '理財詳情',

  'menu.education.detail': '教育詳情',

  'account.real.name.explain.first': '1、根據監管要求，投資前您需要完成開戶流程，填寫相關資料評估是否符合投資者要求。',
  'account.real.name.explain.two': '2、投資證券或金融產品存在潛在的虧損可能，投資者在進行投資前需考慮自身的投資目標及風險承受能力。',
  'account.name.example.title': '照片清晰，完整，無反光',
  'account.name.example.correct.dec': '正確示範',
  'account.name.example.incomplete.dec': '不完整',
  'account.name.example.vague.dec': '模糊',
  'account.name.example.reflective.light.dec': '反光',
  'account.name.example.know': '知道了',
  'account.name.result.title': '認證成功',
  'account.login.ok': '登錄成功',

  'account.open.notice.upload.face': '請上傳正面照',
  'account.open.notice.upload.back': '請上傳背面照',
  'account.open.notice.upload.hand': '請上傳手持照',
  'account.open.notice.upload.all': '請上傳全部圖片',
  'account.open.notice.can.not.openaccount': '風險承受能力項不符合監管要求，您將不能開戶',
  'account.open.form.title.choose': '請完成頁面內容的勾選',
  'account.open.form.work.status': '就業狀態',
  'account.open.form.work.hire': '受雇',
  'account.open.form.work.hire.self': '自雇',
  'account.open.form.work.other': '其它',
  'account.open.education.status': '教育程度',
  'account.open.education.status.primary': '小學或以下',
  'account.open.education.status.middle': '中學',
  'account.open.education.status.college': '大專',
  'account.open.education.status.undergraduate': '本科或以上',
  'account.open.asset.status': '總資產',
  'account.open.asset.status30': '< 30萬',
  'account.open.asset.status100': '30萬-100萬',
  'account.open.asset.status500': '100萬-500萬',
  'account.open.asset.status.more': '>500萬',
  'account.open.asset.year.status': '年收入',
  'account.open.asset.year.status10': '< 10萬',
  'account.open.asset.year.status30': '10萬-30萬',
  'account.open.asset.year.status500': '30萬-500萬',
  'account.open.asset.year.status.more': '>500萬',
  'account.open.invest.target': '投資目標',
  'account.open.invest.target.no.lose': '保本',
  'account.open.invest.target.share': '分紅',
  'account.open.invest.target.all': '投資/投機',
  'account.open.invest.experience': '投資經驗',
  'account.open.invest.experience.no': '沒有',
  'account.open.invest.experience.soso': '一般',
  'account.open.invest.experience.much': '豐富',
  'account.open.affordability.status': '風險承受能力',
  'account.open.taffordability.status.no': '不能容忍虧損',
  'account.open.taffordability.status.low': '低(虧5-10%)',
  'account.open.taffordability.status.mid': '中(虧10-20%)',
  'account.open.taffordability.status.high': '高(虧20%以上)',
  'account.open.notice1': ' 1、根據監管要求，投資前您需要完成開戶流程，填寫相關資料評估是否符合投資者要求。',
  'account.open.notice2': '2、投資證券或金融產品存在潛在的虧損可能，投資者在進行投資前需考慮自身的投資目標及風險承受能力。',
  'account.open.quit.message': '確定退出開戶流程嗎？',
  'account.open.quit.message.present': '確定退出開戶流程嗎？',
  'account.open.vedio.not.support': '抱歉，你的瀏覽器不支持該視頻 ',
  'account.open.vedio.notice': ' 風險提示：所有投資都存在風險。任何一支證券或金融產品的歷史數據都不能保證其未來的表現及回報。雖然投資多樣化可以幫助分散風險，但是並不能在市場低迷時確保您獲益或防止您損失。投資證券或金融產品總會存在潛在的虧損可能。投資者在進行投資前需考慮自身的投資目標及風險承受能力。',
  'account.open.agrement.check': '已閱讀並同意',
  'account.open.agrement.check.customer.file': '《客戶協議書》',
  'account.open.agrement.check.risk': '《風險披露》',
  'account.open.agrement.check.no.usa': '《W-8Ben非美國人免稅表格》',
  'account.open.agrement.check.commitment': '《投資者承諾書》',
  'account.open.agrement.check1': '本人是該證券賬戶的最終且唯一受益人',
  'account.open.agrement.check2': '本人與本證券公司的董事和雇員沒有任何關系',
  'account.open.agrement.check3': '本人不是任何交易所，證券公司，或其他金融機構的持牌人，雇員，董事，高管',
  'account.open.agrement.check4': '本人沒有擔任任何重要公職，例如政府機關，軍隊，國有機構的重要崗位',
  'account.open.agrement.check5': '本人不是美國永久居民(綠卡持有者)',
  'account.open.end.jump': '已開戶，3秒後跳轉到首頁',
  'account.open.need.mobile': '未綁定手機，請先綁定手機',
  'account.open.need.email': '未綁定郵箱，請先綁定郵箱',

  'account.open.end.notice1': '您的申請資料已提交審核，預計一小時內完成審核並開戶',
  'account.open.end.notice2': '預計一小時內完成審核並開戶',
  'account.open.end.notice3': '添加企業微信客服號：',
  'account.open.end.notice4': '即可獲取價值5000元的限量新手大禮包',
  'account.open.end.notice5': '祝您投資愉快！',
  'account.open.end.notice': '您的申請資料已提交審核，預計一小時內完成 審核並開戶。',
  'account.open.end.checking': '正在審核中',
  'account.open.no.liveFace': '未采集人臉圖片，請重新認證',
  'account.open.upload.img.fail': '圖片上傳失敗，請重試',
  'account.open.has.idNumber': '該證件號已存在',
  'account.open.finish.info': '請完善信息',
  'account.open.upload.img': '請上傳圖片信息',
  'account.open.face.live': '請先進行人臉識別',
  'account.open.ocr.finished': 'ocr已識別',
  'account.open.ocr.fail': '接口超時或網絡異常，請重新上傳圖片',
  'account.open.lining.police': '正在連接公安部驗證證件真偽',
  'account.open.comparing': '正在人證合一對比',
  'account.open.compare.approve': '人證合一通過',
  'account.open.compare.fail': '人證合一未通過,請重試',
  'account.open.check.approve': '已通過公安部身份驗證',
  'account.open.check.fail': '未通過公安部身份驗證',
  'account.open.check.api.fail': '公安部身份驗證失敗，請重試',

  'account.open.phone.code.fail': '手機驗證碼校驗錯誤',
  'account.open.set.password.success': '登錄密碼設置成功',
  'account.open.bind.phone.success': '手機綁定成功',
  'account.open.bind.email.success': '郵箱綁定成功',
  'account.open.set.password.fail': '登錄密碼設置失敗，重新設置',
  'account.open.bind.phone.fail': '手機綁定失敗，重新綁定',
  'account.open.bind.email.fail': '郵箱綁定失敗，重新綁定',
  'account.open.bind.success': '綁定並且設置成功',

  'account.open.sign.title': '手寫簽名',
  'account.open.sign.desc': '請確保您的手寫簽名與開戶本人姓名保持一致。',
  'account.open.sign.reset': '重寫',
  'account.open.sign.confirm': '確認簽名',
  'account.open.sign.alert': '請完成手寫簽名',

  'v3.menu.share.open.title': 'WBroker開戶',
  'v3.menu.share.open.verify': 'WBroker實名認證',
  'v3.menu.share.open.add.info': '信息補充',
  'quotation.open.account': '開戶',
  'quotation.margin.account': '開戶升级',
  'menu.user.safe.setting': '設置',
  'message.mail.bind-by-other': '該郵箱已經被綁定！',
  'message.code.error': '驗證碼錯誤！',
  'form.suffix.get.verify.code': '獲取驗證碼',

  'message.login.send.success': '發送成功',

  'asset.account.open.wait.notice': '溫馨提示',


  'form.account.address.title': '開戶證件所屬地區',
  'form.placeholder.input.password': '8-12位字符',
  'form.choose.address': '選擇地區短號',
  'form.search.address': '搜索國家地區名稱/國際區號',
  'form.search.input': '搜索',

  'account.plan.join': '加入計劃',

  'menu.knight.rule': '騎士規則',

  'menu.user.safe.update.next': '下一步',

  'menu.notification.detail': '詳情',

  'menu.help.detail': '幫助中心',
  'help.resolve.problem': '是否解決了您的問題？',
  'help.resolve.problem.yes': '是',
  'help.resolve.problem.no': '否',
  'help.relate.title': '相關問題',
  'help.answer.noUse1': '仍有疑問嗎？聯系',
  'help.answer.noUse2': '在線客服',
  'help.answer.noUse3': ' ',
  //仍有疑問嗎？聯系${在線客服}

  'form.account.type9': '本地身份證',
  'form.account.type4': '駕照',
  'form.stock.hk': '港股',
  'form.stock.us': '美股',
  'form.stock.zht': '中華通',
  'form.stock.aex': '數字貨幣',
  'form.account.openMarket.title': '開通市場類型',
  'account.open.agrement.aex.risk': '《數字貨幣風險披露》',
  'account.open.agrement.laundering': '《反洗錢條約》',
  'account.open.setPsw.title': '設置初始交易密碼',
  'account.open.setPsw.title.confirm': '請再次確認交易密碼',
  'account.open.setPsw.tip': '請輸入6位數字',
  'account.open.setPsw.error': '密碼不一致，請重新輸入',
  'account.open.setPsw.bottom.tip': '*請牢記次密碼，涉及交易和資金等影響賬戶安全的操作，都需要校驗交易密碼',

  'account.open.market.tip1': '賬戶需默認開通',
  'account.open.market.tip2': '市場',
  //賬戶需默認開通${港股}市場

  'help.thanks.feedBack': '感謝您的反饋',
  'component.result.back': '返回',



  'account.open.agrement.check.hkLetter.file': '《香港投資者識別碼製度-個人客戶同意函》',

  'menu.pi.title': '專業投資者認證',
  'pi.Title1': '什麽是專業投資者？',
  'pi.Title1.desc': '根據《證券及期貨（專業投資者）規則》，在最近12個月內擁有投資組合≥八百萬港幣（或等值貨幣）的個人投資者，或擁有投資組合≥八百萬港幣（或等值貨幣）或擁有總資產≥四千萬港幣（或等值貨幣）的任何法團/合夥、獲托付的總資產不少於四千萬港幣（或等值貨幣）的任何信托法團，及符合要求的其他專業法團，經過認證，審核通過後可被視為專業投資者。',
  'pi.Title2': '如何認證專業投資者？',
  'pi.chooseItem1': '方式一：在WBroker持有資產800萬港幣以上',
  'pi.chooseItem2': '方式二：提交持有等值800萬港幣以上',
  'pi.chooseItem3': '資產證明',
  //方式二：提交持有等值800萬港幣以上資產${資產證明}
  'pi.modal.title': '資產證明要求',
  'pi.modal.tip1': '有效資產類型：現金、銀行存款及證券（股票、基金、債券等）。',
  'pi.modal.tip2': '另：房產物業等固定資產證明，暫不記為有效憑證。',
  'pi.btn.text': '立即認證',
  'pi.risk.desc1': '請仔細閱讀以下有關被視作專業投資者的風險及後果:',
  'pi.risk.desc2': '1.申請成為專業投資者之後，WBroker可以為您提供更多的投資產品。但該類投資產品有可能未經香港證監會認可及不受香港證監會規管，因此您投資該類產品會帶有一定的風險。建議您在申請前先咨詢獨立第三方的專業意見。',
  'pi.risk.desc3': '2.在您申請成為專業投資者之後，WBroker可豁免履行以下義務：',
  'pi.risk.desc4': 'i. 提供有關WBroker雇員及其他代表WBroker行事的人士的身份和受雇狀況的資料',
  'pi.risk.desc5': 'ii. 向您確認有關該宗交易的重點。',
  'pi.risk.desc6': 'iii. 向您提供香港聯合交易所有限公司規定的關於納斯達克-美國證券交易所試驗計劃的數據文件。',
  'pi.risk.desc7': 'iv. 根據《證券及期貨(成交單據、戶口結單及收據)規則》的要求向您提供任何成交單據、戶口結單或收據。請註意，並非WBroker將停止向您履行以上義務，但是WBroker有權豁免履行。',
  'pi.risk.desc8': '3. 您若發現已不再符合專業投資者資格，必須立刻告知WBroker。您亦有權可隨時通知WBroker，取消專業投資者資格。',
  'pi.statement.title': '閱讀聲明',
  'pi.statement.desc1': '我確認持有不少於八百萬港幣 (或等值外幣)的投資組合。(投資組合指所持有的現金、存款和《證券及期貨條例》所定義的證券) ',
  'pi.statement.desc2': '我為專業投資者在此聲明，WBroker將豁免履行操守準則及其它香港相關法規中的某些要求。雖然WBroker實際上可能采取下述的一部分或全部行動，但WBroker獲豁免履行下列義務：',
  'pi.statement.desc3': '1.提供有關其雇員及其他代表其行事的人士的身份和受雇狀況的資料。',
  'pi.statement.desc4': '2.確認有關該宗交易的重點。',
  'pi.statement.desc5': '3.提供香港聯合交易所有限公司規定的關於納斯達克-美國證券交易所試驗計劃的資料文件。',
  'pi.statement.desc6': '4.根據證券及期貨(成交單據、戶口結單及收據)規則的要求提供任何成交單據、戶口結單或收據。',
  'pi.statement.desc7': '我在此確認：',
  'pi.statement.desc8': '1.在本評估及聲明表格內提供的信息準確無誤；',
  'pi.statement.desc9': '2.我完全了解被界定為專業投資者的風險及後果；',
  'pi.statement.desc10': '3.我明白提交本評估表格不代表我已經獲批成為專業投資者；',
  'pi.statement.desc11': '4.WBroker可以不提供任何理由而拒絕批準我成為專業投資者；',
  'pi.statement.desc12': '5.我若發現已不再符合《證券及期貨(專業投資者)規則》關於專業投資者的定義時，必須立刻告知WBroker；',
  'pi.statement.desc13': '6.獲告知有需要可以提出問題及征求第三方獨立的意見。',
  'pi.asset.imgUpload.toast': '請上傳憑證',
  'pi.authStatus.reAuth': '重新認證',
  'pi.authStatus.CERTIFIED': '已認證',
  'pi.authStatus.REVIEW': '審核中',
  'pi.auth.liveFace': '請先通過人臉識別',
  'pi.auth.liveFace.fail': '人臉識別失敗，請重試',
  'pi.auth.upload.title': '上傳資產憑證',
  'pi.auth.upload.desc1': '有效資產類型：12個月以內的現金、銀行存款及證券（股票、基金、債券等）的賬戶結單、證明書。',
  'pi.auth.upload.desc2': '註：房產物業等固定資產證明，暫不記為有效憑證。',
  'pi.auth.asset.desc1': '您在WBroker的凈資產合計折算為',
  'pi.auth.asset.desc2': '港幣，避免市場波動導致的資產不足，請保證凈資產的充余。',
  //您在WBroker的凈資產合計折算為XXX港幣，避免市場波動導致的資產不足，請保證凈資產的充余。
  'pi.auth.asset1': 'WBroker凈資產',
  'pi.auth.asset2': '港幣',
  //WBroker凈資產XXX港幣
  'pi.auth.btn': '一鍵認證',
  'pi.auth.result.tip': '您的認證資料已提交審核，預計1-2個工作日內完成審核',
  'pi.auth.not.approve.reason': '未通過原因:',

  'stock.approving': '開戶審核中',

  'menu.active.rule': '活動規則',


  'menu.name.zh': '姓名',
  'menu.name.zh.placeholder': '請填寫真實姓名,示例：張三',
  'menu.name.zh.first': '姓(拼音)',
  'menu.name.zh.first.placeholder': '示例：ZHANG',
  'menu.name.zh.second': '名(拼音)',
  'menu.name.zh.second.placeholder': '示例：SAN',
  'user.cancel': '取消',
  'user.ok': '確認',
  'user.year': '年',
  'user.month': '月',
  'user.date': '日',
  'user.country': '國籍',
  'user.tax.country': '報稅地區',
  'user.birthday': '出生日期',
  'user.birthday.placeholder': '請選擇出生日期',
  'user.date.choose': '請選擇日期',
  'user.experied.date': '有效期截止',
  'user.experied.placeholder': '請選擇證件有效期',
  'user.experied.long.term': '長期有效',
  'user.forth.tip1': '當您點擊',
  'user.forth.tip2': '「已閱讀」',
  'user.forth.tip3': '按鈕，表示您已閱讀並了解上述風險',
  //當您點擊${「已閱讀」}按鈕，表示您已閱讀並了解上述風險
  'user.forth.btn': '已閱讀',

  'menu.name.zh.first.other': '姓(英文)',
  'menu.name.zh.second.other': '名(英文)',

  'open.account.file.title': '協議簽署',
  'open.account.file.desc': '本人已詳細閱讀並同意簽署以下所有開戶文件',
  'open.account.file.title2': '個人聲明',

  'user.getVerifyCodeFirst': '請先獲取驗證碼',

  'menu.updateInfo': '更新賬戶信息',
  'update.info.idcard': '證件類型',
  'update.face.now': '實時人臉識別',
  'update.result.text': '您的賬戶更新信息已提交，預計1-2小時內審核通過',
  'update.result.tip1': '如需幫助請聯系',
  'update.result.tip2': '在線客服',
  'update.result.tip3': '',
  'menu.name.zh.cn': '姓名(中文)',

  'menu.trs.title': 'TRS認證',
  'tres.error.message940104': 'pi認證未通過，無法開通trs賬戶',
  'tres.error.message940103': '有非港幣資產/負債，無法開通trs賬戶',
  'tres.error.message44444': '當前狀態有誤，無法開通trs賬戶',
  'tres.error.message12': '交易密碼錯誤',
  'trs.first.title1': 'TRS認證需準備以下材料：',
  'trs.first.prepare1': '1.在有效期內的護照或港澳通行證，用於拍照上傳。',
  'trs.first.prepare2': '2.近3個月的地址證明。',
  'trs.first.prepare3': '3.最近12個月內，擁有不少於港幣八百萬或等值外幣的投資組合的戶口結單（正本資產證明）。',
  'catch.error': '請求超時或者網絡異常，請稍後再試',
  'trs.first.title2': '請選擇證件所屬地區',
  'trs.first.address.label': '證件所屬地區',
  'trs.first.title3': '請選擇認證證件類型',
  'trs.first.passport': '護照',
  'trs.first.Permit': '港澳通行證',
  'trs.first.save.code': '保存圖片',
  'trs.first.contact.wachat': '添加TRS專屬服務顧問微信',
  'trs.first.mobile': '客服電話：',
  'trs.second.finish.pic': '請完善圖片信息',
  'trs.second.passport.font': '上傳護照展開頁',
  'trs.second.passport.hand': '上傳手持護照照片',
  'trs.second.pic.font': '上傳證件照正面',
  'trs.second.pic.back': '上傳證件照反面',
  'trs.second.open.type': '證件類型',
  'trs.second.input.placeholder': '請輸入',
  'trs.second.living.address': '居住地址',
  'trs.second.living.address.placeholder': '請輸入居住地址',
  'trs.second.address.img': '地址證明(水電賬單，信用卡賬單等，須寫明您的姓名的地址)',
  'trs.second.address.img.text': '點擊上傳地址證明',
  'trs.second.info': '結單信息',
  'trs.second.info.desc': '最近12個月內，擁有不少於港幣八百萬或等值外幣的投資組合的戶口結單（正本資產證明）',
  'trs.second.info.img': '點擊上傳結單信息',
  'trs.second.upload.meterial': '上傳材料',
  'trs.fifth.ageGroupList1': '18-24歲',
  'trs.fifth.ageGroupList2': '25-34歲',
  'trs.fifth.ageGroupList3': '35-50歲',
  'trs.fifth.ageGroupList4': '51-64歲',
  'trs.fifth.ageGroupList5': '超過65歲',
  'trs.fifth.highestEducationList1': '小學或以下',
  'trs.fifth.highestEducationList2': '中學',
  'trs.fifth.highestEducationList3': '大學或以上',
  'trs.fifth.highestEducationList4': '專業資格(與會計/經濟/金融學相關)',
  'trs.fifth.sourcesOfFundingList1': '薪金/傭金',
  'trs.fifth.sourcesOfFundingList2': '租金',
  'trs.fifth.sourcesOfFundingList3': '股息/利息',
  'trs.fifth.sourcesOfFundingList4': '營業利潤',
  'trs.fifth.sourcesOfFundingList5': '其他',
  'trs.fifth.ageGroup': '年齡組別',
  'trs.fifth.please.choose': '請選擇',
  'trs.fifth.highestEducation': '最高學歷',
  'trs.fifth.liquidAsset': '流動資產',
  'trs.fifth.netAsset': '資產凈值',
  'trs.fifth.annualSalary': '年薪',
  'trs.fifth.sourcesOfFunding': '資金來源',
  'trs.fifth.finance.status': '財政狀況',
  'trs.sixth.title': '風險問卷',
  'trs.sixth.tip': '請先完成風險問卷中的問題',
  'trs.sixth.question1': '1、按閣下的每月平均家庭開支計算，閣下預留多少資金作為緊急用途（包括現金及任何高流動性資產，如交投活躍的股票、基金）？',
  'trs.sixth.invest1List1': '少於1個月的家庭開支',
  'trs.sixth.invest1List2': '1個月至6個月以下的家庭開支',
  'trs.sixth.invest1List3': '6個月至12個月以下的家庭開支',
  'trs.sixth.invest1List4': '12個月至24個月以下的家庭開支',
  'trs.sixth.invest1List5': '24個月或以上的家庭開支',
  'trs.sixth.invest2List1': '少於1年',
  'trs.sixth.invest2List2': '1-3年',
  'trs.sixth.invest2List3': '3-5年',
  'trs.sixth.invest2List4': '5-10年',
  'trs.sixth.invest2List5': '超過10年',
  'trs.sixth.invest3List1': '少於5%',
  'trs.sixth.invest3List2': '5%至10%以下',
  'trs.sixth.invest3List3': '10%至20%以下',
  'trs.sixth.invest3List4': '20%至30%以下',
  'trs.sixth.invest3List5': '30%或以上',
  'trs.sixth.invest4List1': '少於10%',
  'trs.sixth.invest4List2': '10%至20%以下',
  'trs.sixth.invest4List3': '20%至30%以下',
  'trs.sixth.invest4List4': '30%至40%以下',
  'trs.sixth.invest4List5': '40%或以上',
  'trs.sixth.invest5List1': '-5%至+5%之間的波動',
  'trs.sixth.invest5List2': '-10%至+10%之間的波動',
  'trs.sixth.invest5List3': '-20%至+20%之間的波動',
  'trs.sixth.invest5List4': '-30%至+30%之間的波動',
  'trs.sixth.invest5List5': '低於-30%及高於+30%的波動',
  'trs.sixth.invest6List1': '我的投資目標為保本主導。我期望獲得稍高於銀行存款利率的投資回報，我可以承受輕微程度的資本損失。',
  'trs.sixth.invest6List2': '我的投資目標為收入主導。我期望獲得高於定期存款利率的穩定收入或抵抗通脹的定期回報，我可以承受較低資本失。',
  'trs.sixth.invest6List3': '我的投資目標為收入及增長主導。我期望獲得來自資本增長及穩定收入的回報，我可以承受中等水平的投資風險。',
  'trs.sixth.invest6List4': '我的投資目標為增長主導。我期望獲得來自資本增值為主而較少比重於固定收益的回報，我願意承受較高的風險以換取更高的回報。',
  'trs.sixth.invest6List5': '我的投資目標為積極增長。我期望爭取最高回報，我願意承受極高的資本損失，甚至能承受虧損大於起初的投資本金。',
  'trs.sixth.invest7List1': '沒有任何資金損失',
  'trs.sixth.invest7List2': '損失至10%',
  'trs.sixth.invest7List3': '損失至20%',
  'trs.sixth.invest7List4': '損失至20%',
  'trs.sixth.invest7List5': '全部損失',
  'trs.sixth.question2': '2、請問以下哪一項是能令您感到安心的最長投資年期？',
  'trs.sixth.question3': '3、閣下願意撥出多少稅後收入作為儲蓄或投資用途?',
  'trs.sixth.question4': '4、閣下用作投資的資金平均佔閣下的總資產淨值（不包括自住物業）多少百分比？',
  'trs.sixth.question5': '5、閣下願意接受最大程度的價格波動是多少？',
  'trs.sixth.question6': '6、閣下對投資回報與風險所持的一般態度是？',
  'trs.sixth.question7': '7、閣下可以接受的投資金額的潛在損失為多少？',
  'trs.seventh.tip': '請先完成風險問卷中投資經驗相關問題',
  'trs.seventh.title': '風險問卷',
  'trs.seventh.title.desc': '8、請選擇下列投資產品的投資經驗',
  'trs.seventh.investList1': '無經驗',
  'trs.seventh.investList2': '0-3年',
  'trs.seventh.investList3': '4-6年',
  'trs.seventh.investList4': '7-10年',
  'trs.seventh.investList5': '超過10年',
  'trs.seventh.question1': '(1).股票',
  'trs.seventh.question2': '(2).不同風險類別的交易所買賣基金',
  'trs.seventh.question3': '(3).不同風險類別的非交易所買賣基金，如互惠金、單位信託基金、對沖基金、私募股權基金等',
  'trs.seventh.question4': '(4).不同風險類別的固定收益產品，如債券',
  'trs.seventh.question5': '(5).固定收益產品（複雜類別），具有特殊性質，如永續性質、可換股性質、可贖回性質等',
  'trs.seventh.question6': '(6).上市衍生工具／結構性產品，如股票期權、期貨、期貨期權、認股權證等',
  'trs.seventh.question7': '(7).場外衍生工具／結構性產品，如累計期權等',
  'trs.seventh.question8': '(8).杠桿外匯投資',
  'trs.seventh.question9': '(9).其他',
  'trs.seventh.question9.placeholder': '選填',
  'trs.eighth.title': '衍生品及結構性產品認識',
  'trs.eighth.question1': '1、您是否接受過有關衍生產品或結構性的培訓或修讀相關課程?',
  'trs.eighth.question1.1': '培訓或修讀課程名稱：',
  'trs.eighth.question1.2': '培訓或修讀日期：',
  'trs.eighth.question2': '2、您現在或過去有與衍生產品或結構性有關的工作經驗?',
  'trs.eighth.question2.1': '您的雇主名稱是：',
  'trs.eighth.question2.2': '在職日期：',
  'trs.eighth.question3': '3、您曾否在以往三年內執行過五宗或以上衍生產品或結構性交易?',
  'trs.eighth.yes': '是',
  'trs.eighth.no': '否',
  'trs.ninth.title1': '免責聲明',
  'trs.ninth.title1.desc1': '1. 本問卷內的風險評估分析結果乃根據閣下向WBroker所提供的資料透過預設的投資風險評估程序所得。旨在協助閣下明白本身的投資需要及個人風險取向，並僅作參考用途。WBroker對風險評估分析結果的準確性及完整性並不作出任何聲明或保證。分析可基於某些假設。預測的回報未必可以達到，參考結果可因既定的假設或閣下提供資料有所改變而受影響。因此，WBroker不會就此文件內所載資料或結果的準確性及完整性或閣下倚賴該等資料或結果所招致的任何後果而承擔任何責任。',
  'trs.ninth.title1.desc2': '2. 閣下於作出任何投資決定前，需仔細考慮閣下的財務狀況、投資經驗、投資目標及風險承受能力。而且，閣下應進一步諮詢專業投資顧問，以更全面了解投資證券所涉及的風險，包括（但不限於）市場風險、政治風險、信貸風險、經濟風險及貨幣風險。閣下因應本文件的資料而作出的投資決定，WBroker恕不為該投資結果負責。',
  'trs.ninth.title1.desc3': '3. 與大多數投資項目類似，投資產品的價值可升可跌。因此，閣下可能因投資期間出現的不利市場狀況而承受重大的投資損失。閣下應根據自身風險承受能力及情況而投資。本文件所包含之投資選擇僅作參考用途，並不能代替適當的專業投資建議。',
  'trs.ninth.title1.desc4': '4. WBroker有權不時更改或修訂本文件之內容而無須作事先通知。如有任何爭議，WBroker有最終決定權。',
  'trs.ninth.title1.desc5': '5. 此文件所載資料只備作參考用途，並不構成任何金融產品之要約、遊說、邀請、意見或建議。投資涉及風險，過往的表現不能預示將來的表現，在作出投資前，閣下應參閱有關招售文件內的詳細資料。',
  'trs.ninth.title1.desc6': '6. 如閣下對此資料有疑問，應尋求獨立專業財務、稅務及法律意見。',
  'trs.ninth.title2': '個人資料收集聲明',
  'trs.ninth.title2.desc': '收集之個人資料將被使用於以下用途。基於實際的商業及營運需要，該等資料可能被（i）WBroker任何成員之行政、運作及資訊科技部門；（ii）任何向WBroker提供服務之供應商，而該服務供應商就其提供有關服務是有合理需要知道相關資料的；（iii）任何與WBroker有業務關係的商業夥伴或其他金融產品發行人，而該夥伴或發行人就其提供有關金融產品予客戶是有合理需要知道相關資料的；及（iv）任何對WBroker任何成員具有適當管轄權之政府機關、司法機關、法定機關或業界自我監管機關。除用於上述目的外，閣下之個人資料將會保密。如此表格不再適用於以上所提及之任何用途，將於其後一年內被銷毀；但此表格可能會被保留一段相當時間，以符合有關法律及監管要求。',
  'trs.tenth.tip1': '請勾選個人聲明',
  'trs.tenth.tip2': '請先完成簽署協議',
  'trs.tenth.title1': '個人聲明',
  'trs.tenth.title1.desc1': '本人確認本人的上述回答為真實、正確而且準確的；',
  'trs.tenth.title1.desc2': '本人確認WBroker可根據本人提供的信息來確定本人的風險狀況，以及適合本人的投資產品類型；',
  'trs.tenth.title1.desc3': '如本人在填寫的資料有任何變動，本人同意以書面形式通知WBroker，並明白WBroker將繼續依照記錄中的最新版本，直至WBroker收到我所提供的更新版本為止；',
  'trs.tenth.title1.desc4': '本人確認已根據填寫指引，提供本認證的答案，亦明白WBroker在評估投資產品對帳戶的合適性時，可能會參照本問卷的答案，盡管該帳戶的其他帳戶持有人可能分別具有不同的投資知識和經驗，風險，能力，風險承受能力，財務狀況和投資目標；',
  'trs.tenth.title1.desc5': '本人已閱讀，明白並同意包括本認證內容內所有細節；',
  'trs.tenth.title1.desc6': '本人了解由本人提供的任何欠缺準確性或不完整的信息，都可能影響WBroker對本人所提供的投資產品和服務適用性評估；',
  'trs.tenth.title1.desc7': '本人明白並接受WBroker不會為本人做出任何最終投資決定，本人需要為自己的投資決定負責，包括所提供的產品或服務，最終是否滿足本人個人需求或情況。',
  'trs.tenth.title2': '簽署協議',
  'trs.tenth.title2.desc': '本人已詳細閱讀並同意簽署以下所有認證協議',
  'trs.result.desc': '您的認證資料已提交審核，預計1-2個工作日內完成審核。',
  'trs.result.back.homePage': '返回首頁',
  'update.info.checking': '您已提交賬戶信息，請耐心等待審核！',

  'trust.fixedAmountLimit.label': '認購金額',
  'trust.fixedAmountLimit.label.placeholder': '請輸入認購金額',
  'trust.purchurs.amount.label': '認購份額',
  'trust.intrustCode.label': '邀請碼',
  'trust.intrustCode.placeholder': '請輸入邀請碼',
  'trust.password.label': '交易密碼',
  'trust.password.placeholder': '請輸入交易密碼',
  'trust.sell.label': '贖回份額',
  'intrust.title': '信托詳情',
  'intrust.his.tab.title': '歷史凈值',
  'intrust.his.amount.shares': '份',

  'menu.report.detail': '詳情',

  'ipo.header.title': '信托詳情',
  'ipo.subscription.header.title': '認購',
  'IpoResult.header.title': '認購',
  'ipo.per.amount': '每份投資金額',
  'ipo.amount.placeholder': '請輸入認購份額',
  'trs.asset.cashValue': '可用現金:',
  'ipo.limit': '*限購',
  'ipo.limit1': '份',
  'ipo.tip': '*交易日16:00-20:00時可能因系統結算導致認購失敗',
  'ipo.contract1': '已閱讀並同意電子簽署',
  'ipo.contract2': '協議',
  'ipo.time': '認購時間',
  'ipo.product': '產品',
  'ipo.sucess': '認購成功',
  'ipo.error170014': '認購代碼無效',
  'ipo.error171000': '認購數量錯誤',
  'ipo.error171001': '認購數量超過個人額度',
  'ipo.error171002': '已售罄',
  'ipo.error171003': '暫不支持贖回',

  'raffle.index.title': '新年抽股大放送',
  'update.man': '男',
  'update.woman': '女',
  'update.sex': '性别',
  'account.bank.no.label': '銀行卡號',
  'account.bank.no.placeholder': '請輸入大陸銀聯銀行卡號',
  'account.bank.account.name.label': '銀行開戶戶名',
  'account.bank.account.mobile.label': '手機號',
  'account.bank.account.mobile.placeholder': '請輸入銀行開戶預留手機號',
  'account.ca.tips1': '1、根據監管要求，投資前您需要完成開戶流程，填寫相關資料評估是否符合投資者要求。',
  'account.ca.tips2': '2、華通國際將會對您的信息進行嚴格保密。',
  'account.ca.tips3': '3、此銀行卡僅用於身份實名認證。',
  'ca.error.tip': 'Ca認證失敗:',
  'ca.menu.title': '身份認證',
  'ca.index.btn': '開始認證',
  'ca.upload.tip1': '1、華通國際將會對您的信息進行嚴格保密。',
  'ca.upload.tip2': '2、身份證信息僅用於身份實名認證。',
  'agreement.error.tip': '請先勾選協議',
  'ca.index.title': '為了保障您的資產安全，請您完成身份認證',
  'ca.index.tip1': '請您確保環境安靜，光線充足',
  'ca.index.tip2': '請您提前準備好大陸銀聯銀行卡',
  'ca.index.agreement1': '身份認證服務由GDCA提供，本人已閱讀並同意',
  'ca.index.agreement2': 'GDCA數字證書用戶協議',
  'ca.index.agreement3': '和',
  'ca.index.agreement4': '申請數字證書相關條款',

  'account.market.title': '請確認您要開通的賬戶類型',
  'account.market.type1': '孖展（保證金）賬戶',
  'account.market.type1.desc': '孖展（保證金）賬戶，可使用自有現金交易，也可借入資金交易。',
  'account.market.type2': '現金賬戶',
  'account.market.type2.desc': '現金賬戶，僅可使用自有現金交易，不允許借貸融資交易。',
  'account.market.type.title': '請確認您要開通的市場類型',
  'account.market.type.HK': '港股',
  'account.market.type.US': '美股',
  'account.market.type.CN': '中華通',
  'open.end.tips1': '開戶資料已提交',
  'open.end.tips2': '預計在1個工作日內開戶成功',

  'update.place.of.birth': '出生地',
  'update.residence': '常駐地區',
  'form.account.valuation2': '估值（扣除按揭）',
  'account.open.form.work.unemployed': '待業',

  'account.open.bank.name': '银行名称',

  'account.open.asset.status20': '< 20万',
  'account.open.asset.status2050': '20万-50万',
  'account.open.asset.status50100': '50万-100万',
  'account.open.asset.status100500': '100万-500万',
  'account.open.asset.status5001000': '500万-1000万',
  'account.open.asset.status.1000+': '>500万',
  'account.open.asset.status.Negative.equity': '负资产',
  'account.open.asset.year.status20': '< 20万',
  'account.open.asset.year.status2050': '20万-50万',
  'account.open.asset.year.status50100': '50万-100万',
  'account.open.asset.year.status100500': '50万-100万',
  'account.open.asset.year.status5001000': '50万-100万',
  'account.open.asset.year.status.1000+': '>1000万',
  'account.open.questionnaire.source.type1': '储蓄',
  'account.open.questionnaire.source.type2': '工资收入',
  'account.open.questionnaire.source.type3': '租金',
  'account.open.questionnaire.source.type4': '家族继承',
  'account.open.questionnaire.source.type5': '创业',
  'account.open.questionnaire.source.type6': '投资收益',
  'account.open.questionnaire.source.type7': '其他',
  'account.open.questionnaire.objective.type1': '资本投资',
  'account.open.questionnaire.objective.type2': '对冲',
  'account.open.questionnaire.objective.type3': '投机',
  'account.open.questionnaire.objective.type4': '股息/利息收入',
  'account.open.questionnaire.title1': '就业情况',
  'account.open.questionnaire.title2': '公司名称',
  'account.open.questionnaire.title3': '职业/职务',
  'account.open.questionnaire.title4': '职务年期',
  'account.open.questionnaire.title5': '职位',
  'account.open.questionnaire.title6': '教育情况',
  'account.open.questionnaire.title7': '收入情况',
  'account.open.questionnaire.title8': '净资产',
  'account.open.questionnaire.title9': '财富来源(可多选)',
  'account.open.questionnaire.title10': '交易资金来源(可多选)',
  'account.open.questionnaire.title11': '投资目的',
  'account.open.questionnaire.title12': '投资经验',
  'account.open.questionnaire.title13': '投资杠杆',
  'account.open.questionnaire.title14': '投资贵金属',
  'account.open.questionnaire.title15': '投资期权',
  'account.open.questionnaire.title16': '衍生品知识',
  'account.open.questionnaire.title17': '风险承受能力',
  'account.open.questionnaire.title18': '净资产(港币)',
  'account.open.questionnaire.title19': '不包括居住地方、汽车、家私、个人物品及人寿保险',
  'account.open.questionnaire.title20': '投资股票、债券及其他证券',
  'account.open.questionnaire.title21': '投资杠杆外汇',
  'account.open.questionnaire.title22': '投资贵重金属',
  'account.open.questionnaire.title23': '投资期货/期权',
  'account.open.questionnaire.title24': '是否了解衍生产品',
  'account.open.questionnaire.title25': '年收入(港币)',

  'margin.tips': '投資證券或金融產品存在潛在的虧損可能，投資者在進行投資前需考慮自身的投資目標及風險承受能力。',
  'margin.end': '賬戶已升級',
  'margin.agreement.tips': '本人已詳細閱讀並同意簽署',
  'margin.agreement.tips2': '《賬戶升級授權書》',
}
